
import { Vue, Component, Prop } from "vue-property-decorator";
// import StorageCartModule from "@/store/modules/storage/storageCart.module";
import { StorageElements } from "@/models/entities/storage/storageElements.interface";
@Component
export default class CartBody extends Vue {
  @Prop({ required: true, default: [] })
  private elementsList: StorageElements[];
  private removeElement(element: StorageElements): void {
    this.$emit("removeElement", element);
  }
  private addQty(element: StorageElements): void {
    this.$emit("addQty", element);
  }
  private removeQty(element: StorageElements): void {
    this.$emit("removeQty", element);
  }
  private checkQty(element: StorageElements): void {
    this.$emit("checkQty", element);
  }
}
